export const environment = {
  name: 'dev',
  production: false,
  maintenanceMode: false,
  apiBaseUrl: 'https://hubx-rma-api-dev-b2fgahfphaa6fcf3.eastus-01.azurewebsites.net/api/',
  sentryDsn: '',
  hubx_auth_domain: 'https://hubx-authenticationapi-dev.azurewebsites.net/',
  hubx_auth_apiUrl: 'https://hubx-authadminapi-dev.azurewebsites.net/',
  hubx_auth_clientId: 'b32dd71bc0254b1391716e6c3ca86890',
  hubx_auth_scope: 'hubx-web-apis-dev',
  hubx_auth_RedirectUrl: 'https://portal-dev.hubx.com/callback',
  hubx_auth_realm: 'rma-dev',
  attachmentBlobBaseUrl: 'https://hubxstorageaccountdev.blob.core.windows.net/rma-claims',
};
